import * as types from '../mutation-types'

export const state = {
  showSidebar: false,
  isLoading: true,
  menus: {
    navigation: {
      main: [],
      notifications: [],
      events: [],
    },
    globalMenu: [],
    userMenu: [],
    footerMenu: [],
  },
}

export const getters = {
  navigationMain(state) {
    if (!state.menus) return false
    if (!state.menus.navigation) return false
    if (!state.menus.navigation.main) return false
    return state.menus.navigation.main
  },
  showSidebar(state) {
    return state.showSidebar
  },
  isLoading(state) {
    return state.isLoading
  },
}

export const mutations = {
  [types.TOGGLE_SIDEBAR](state, newValue) {
    state.showSidebar = newValue
  },
  [types.TOGGLE_LOADING](state, newValue) {
    state.isLoading = newValue
  },
  [types.ADD_MENU_ITEM](state, menuItem) {
    let _pluginArea = null
    if (menuItem.pluginArea.indexOf('.') !== -1) {
      let _areas = menuItem.pluginArea.split('.')
      _pluginArea = state.menus[_areas[0]][_areas[1]]
    } else {
      _pluginArea = state.menus[menuItem.pluginArea]
    }

    if (_pluginArea) {
      var foundIndex = _pluginArea.findIndex(
        (item) => item.target === menuItem.target
      )
      if (foundIndex > 0) {
        // menu item alread in the list - update it
        _pluginArea[foundIndex] = menuItem
      } else {
        // item not in the list yet so add it
        _pluginArea.push(menuItem)
      }
    } else {
      throw Error('Invalid plugin area.')
    }
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state /*, dispatch */ }) {
    notImplemented(state)
  },
  displaySidebar({ commit /*, state */ }, value) {
    // console.log(value)
    if (!value) value = false
    commit(types.TOGGLE_SIDEBAR, value)
  },
  displayLoadingScreen({ commit /*, state */ }, value) {
    // console.log(value)
    if (!value) value = false
    commit(types.TOGGLE_LOADING, value)
  },
  addMenuItem({ commit /*, state */ }, menuItem) {
    // TODO: Add additional checks for valid menu item
    if (menuItem.visible) commit(types.ADD_MENU_ITEM, menuItem)
  },
}

// ===
// Private helpers
// ===

function notImplemented(/* state */) {
  // eslint-disable-next-line no-console
  console.log('Layout Store Module Init not Implemented...')
}
